import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { RadiologyConsultationItem } from 'src/app/entities/consultation.entity';
import { RadiologiesService } from 'src/app/services/radiologies.service/radiologies.service';
import { RadioFilter } from '../../radiology-form.module/radio-select-drawer/radio-select-drawer.component';
import { RadioPrescription } from 'src/app/entities/prescription.entity/radio-prescription.entity/radio-prescription';
import { Radiology } from 'src/app/entities/radiology.entity/radiology';
export class ConsultationItemValidation {
  controlsValidation: Record<symbol, symbol | null> = {}
  get isValid(): boolean {
    return Array.from(Object.values(this.controlsValidation)).every(elm => elm === null)
  }
}

export class RadioConsultationnItemValidation extends ConsultationItemValidation {
  controlsValidation: { radio: 'required' | null, note: null } = {
    radio: null,
    note: null,
  };

  constructor(controlsValidation: { radio: 'required' | null, note: | null }) {
    super()
    this.controlsValidation = controlsValidation
  }
}
@Component({
  selector: 'app-radiology-consultation-forms',
  templateUrl: './consultation-radiology-formcomponent.html',
  styleUrls: ['./consultation-radiology-formcomponent.css']
})
export class ConsultationRadiologyFormComponent implements OnInit {

  @Input() radiologyConsultationItems: Array<RadiologyConsultationItem> = new Array();
  @Output() radiologyConsultationItemsChange: EventEmitter<Array<RadiologyConsultationItem>> = new EventEmitter();
  @Input() submitted: boolean = false;
  @Output() validation: EventEmitter<boolean> = new EventEmitter()
  radiologies: Array<Radiology | any> = new Array();
  radiosFilter: Array<RadioFilter> = new Array({ radioPrescription: new RadioPrescription(), selected: false });

  radiologie: string = "";

  drawerActive: boolean = false;
  constructor(private radiologiesService: RadiologiesService, private toasterService: ToastrService) { }
  isValid(): boolean {
    return this.radiologyConsultationItems.every(item => this.validateConsultationItem(item).isValid)
  }
  get groupedRadiologies(): Array<{ keyName: string, items: Array<{ label: string, id: string }> }> {
    let groups: Array<string> = Array.from(this.radiologies, r => r.type_Radio)
    return Array.from(groups, group => {
      let items: Array<{ label: string, id: string }> = new Array();
      this.radiologies.forEach(radio => {
        if (group == radio.type_Radio) items.push({ label: radio.nom_Radio, id: radio.id_RADIO });
      })
      return {
        keyName: group, items: items
      };
    });
  }

  ngOnInit(): void {
    this.radiologiesService.all()?.subscribe({
      next: (res: any) => {
   this.radiologies = res
      },
      error: () => this.toasterService.error('Unable to load radiologies')
    });
  }

  addPrescriptionItem(): void {
    this.radiologyConsultationItems.push(new RadiologyConsultationItem({}));
    this._change();

  }

  deletePrescriptionItem(index: number): void {
    this.radiologyConsultationItems.splice(index, 1);
    this._change();

  }
  validateConsultationItem(radioConsultationItem: RadiologyConsultationItem): RadioConsultationnItemValidation {
    return new RadioConsultationnItemValidation({
      radio: null,//!radioConsultationItem.radio.id_RADIO ? "required" : null,
      note: null,
    });
  }
  onEditPrescriptionItem(index: number): void {
    this._change();

  }
  _change() {
    this.radiologyConsultationItemsChange.emit(this.radiologyConsultationItems)
    this.validation.emit(this.isValid())
  }
  closed(): void {
    this.radiosFilter.map((elm) => {

      return this.radiologyConsultationItems.push(new RadiologyConsultationItem({ radio: elm.radioPrescription.radio }));
    });
    // Étape 1: Utiliser reduce pour compter les occurrences des objets biologie
    const countRadio = this.radiosFilter.reduce((acc, obj) => {
      const radioKey = JSON.stringify(obj.radioPrescription.radio);
      acc[radioKey] = (acc[radioKey] || 0) + 1;
      return acc;
    }, {});

    // Étape 2: Utiliser filter pour sélectionner les objets dont biologie apparaît plus d'une fois
    const radios = this.radiosFilter.filter((obj, index, self) => {
      const radioKey = JSON.stringify(obj.radioPrescription.radio);
      return (
        countRadio[radioKey] > 1 &&
        self.findIndex((o) => this.deepEqual(o.radioPrescription.radio, obj.radioPrescription.radio)) === index
      );
    });


    this.radiosFilter = radios;
    const countRadioItem = this.radiologyConsultationItems.reduce((acc, obj) => {
      const radioKey = JSON.stringify(obj.radio);
      acc[radioKey] = (acc[radioKey] || 0) + 1;
      return acc;
    }, {});

    // Étape 2: Utiliser filter pour sélectionner les objets dont biologie apparaît plus d'une fois
    const radiositem = this.radiologyConsultationItems.filter((obj, index, self) => {
      const radioKey = JSON.stringify(obj.radio);
      return (
        countRadioItem[radioKey] > 1 &&
        self.findIndex((o) => this.deepEqual(o.radio, obj.radio)) === index
      );
    });
    this.radiologyConsultationItems = this.radiologyConsultationItems.filter(elm => elm.radio.nom_Radio !== "")
    this.drawerActive = false;
  }
  deepEqual(obj1, obj2) {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }
}
